import styled from 'styled-components';
import theme from 'src/theme';

type Props = {
    gridCol?: number;
    gridColSpan?: number;
    isHalfWidth?: boolean;
    gridCols?: number;
    resetCols?: boolean;
};

export const LeftContentWrapper = styled.div`
    display: flex;
    justify-content: flex-start;
    padding: 0 1rem 0 0;
    flex: 0 0 auto;
`;

export const RightContentWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 0 10px 0 10p;
`;

export const ChemicalRobWrapper = styled.div`
    height: calc(100% - 60px);
    overflow-y: auto;
    @media print {
        display: block;
        width: 100%;
        height: 100%;
        page-break-after: always;
        overflow: visible;
    }
`;

export const UpdateStatusText = styled.span`
    font-weight: 500;
    font-size: 0.75rem;
    width: max-content;
    height: 20px;
    line-height: 1rem;
    color: #04265a;

    &.status-saved .status-text {
        border-radius: 40px;
        background: #e7e7e7;
        color: #fff;
        background: rgba(16, 124, 16, 1);
        padding: 2px 7px;
        margin-left: 3px;
        font-size: 0.7rem;
    }
`;

export const HeadingWrapper = styled.div`
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #ddd;
    height: 50px;
    background: ${theme.legacyColors.selectedBackground};
    color: ${theme.legacyColors.selectedColor};
    border-bottom: 1px solid ${theme.legacyColors.selectedBorder};
`;

export const InputWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    font-size: 0.9rem;
    margin-bottom: 5px;
`;

export const ChemicalCategoryWrapper = styled.div``;

export const ChemicalCategoryList = styled.ul`
    font-size: 0.8rem;
    width: 100%;
    margin: 5px 0 0 0;
`;

export const ChemicalCategory = styled.div`
    margin: 0 0 10px 0;
`;

export const ChemicalItem = styled.li`
    display: flex;
    justify-content: space-between;
    font-size: 0.9rem;
    margin-bottom: 5px;
`;

export const Heading3 = styled.h3`
    font-size: 0.8rem;
    font-weight: 500;
    text-align: center;
    margin: 0 0 0.5rem;
    padding: 5px 0;
    background: #f4f4f4;
    border-bottom: 1px solid #00447e;
`;

export const RobItemRow = styled.div`
    display: grid;
    grid-template-columns: 23% 6% 20% 20% 20% 6%;
    grid-column-gap: 0.5rem;
    justify-items: flex-start;
    padding: 0 10px;
    font-size: 0.8rem;
    font-weight: 500;

    > label {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 96%;
    }

    .rob-value {
        margin: 0 0 0 5px;
    }
    .unit {
        margin: 0 0 0 3px;
    }
    .location {
        display: flex;
        justify-content: flex-start;
        justify-self: stretch;
        select {
            width: 65px;

            @media only screen and (min-width: 1280px) {
                width: 75px;
            }
            @media only screen and (min-width: 1440px) {
                width: 95px;
            }
            @media only screen and (min-width: 1600px) {
                width: 115px;
            }
        }

        label .input-value-wrapper {
            display: block;
        }
    }
`;

export const RobItemRowHeader = styled.div`
    padding: 0 10px;
    font-size: 0.8rem;
    font-weight: 500;
`;

export const ListValuesWrapper = styled.div<Props>`
    select {
        border: 1px solid #ccc;
        height: 1.5rem;
        border-radius: 3px;
        width: 115px;
    }

    .aggr-rob {
        font-weight: 500;
    }
`;

export const HeaderWrapper = styled.div`
    display: flex;
    justify-content: space-between;

    @media print {
        grid-template-columns: 40% 60%;
        justify-items: flex-start;
    }

    align-items: center;
    padding: 0px 15px 0 7px;
    border-bottom: 1px solid #ccc;
    height: 51px;
`;

export const PrintInfo = styled.div`
    display: none;
    @media print {
        display: block;
    }
`;
